export default __webpack_public_path__ + "static/media/oven_with_buttons.1d937299.svg";